import {createSlice} from "@reduxjs/toolkit";

const initialInvoicesState = {
  listLoading: false,
  totalCount: 0,
  pageCount: 0,
  entities: null,
  error: null,
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const unpaidAgentsSlice = createSlice({
  name: "unpaidAgents",
  initialState: initialInvoicesState,
  reducers: {
    unpaidAgentsFetched: (state, action) => {
      const {totalCount, pageCount, entities} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.pageCount = pageCount;
    },
    unpaidAgentsAppended: (state, action) => {
      const {totalCount, pageCount, entities} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = state.entities ? [...state.entities, ...entities] : [...entities];
      state.totalCount = totalCount;
      state.pageCount = pageCount;
    },
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.unpaidAgentsError = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
  }
});
